import { call, debounce, put, takeLatest } from 'redux-saga/effects';
import {
  fetchSampleDevelopmentHlApprovalRequestList,
  updateSampleDevelopmentHlApprovalRequesResponse,
} from '../../services/sampleDevelopmentHlApprovalRequestService';
import { FAILURE, REQUEST, SUCCESS } from '../../utils/actionTypeUtil';
import { pushNotificationMessage } from '../../views/components/Notification';
import { AppAction } from '../app';
import {
  closeSampleDevelopmentHlApprovalRequestDialog,
  FETCH_SAMPLE_DEV_HL_APPROVAL_REQUEST_LIST,
  UPDATE_SAMPLE_DEV_HL_APPROVAL_REQUEST_RESPONSE,
} from './sampleDevelopmentHlApprovalRequest.actions';

function* fetchSasmpleDevelopmentHlApprovalRequestListSaga(action: AppAction) {
  try {
    yield put({ type: REQUEST(action.type) });
    const response = yield call(
      fetchSampleDevelopmentHlApprovalRequestList,
      action.payload,
    );
    const { data, headers } = response;
    yield put({ type: SUCCESS(action.type), payload: { data, headers } });
  } catch (error) {
    const errorMessage: string = error.response.data.message;
    yield put({ type: FAILURE(action.type), payload: { errorMessage } });
    yield put(pushNotificationMessage({ message: errorMessage, type: 'error' }));
  }
}

function* updateSasmpleDevelopmentHlApprovalRequestResponseSaga(action: AppAction) {
  try {
    const successMessage = `Updated sample development hl approval request successfully.`;
    yield put({ type: REQUEST(action.type) });
    const { data } = yield call(
      updateSampleDevelopmentHlApprovalRequesResponse,
      action.payload,
    );
    yield put({ type: SUCCESS(action.type), payload: { data } });
    yield put(pushNotificationMessage({ message: successMessage, type: 'success' }));
    yield put(closeSampleDevelopmentHlApprovalRequestDialog());
  } catch (error) {
    const errorMessage: string = error.response.data.message;
    yield put({ type: FAILURE(action.type), payload: { errorMessage } });
    yield put(pushNotificationMessage({ message: errorMessage, type: 'error' }));
  }
}

export default function* watchSampleDevelopmentHlApprovalRequest() {
  yield debounce(
    250,
    FETCH_SAMPLE_DEV_HL_APPROVAL_REQUEST_LIST,
    fetchSasmpleDevelopmentHlApprovalRequestListSaga,
  );
  yield takeLatest(
    UPDATE_SAMPLE_DEV_HL_APPROVAL_REQUEST_RESPONSE,
    updateSasmpleDevelopmentHlApprovalRequestResponseSaga,
  );
}
